import React, { Fragment, useState } from "react";
import { Button, UncontrolledTooltip } from "reactstrap";
import { FormattedMessage } from "react-intl";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheckDouble } from '@fortawesome/free-solid-svg-icons';
import { Link } from "react-router-dom";
import {
  ACL,
  TICKETS_STATUSES
} from "../../../../../config/constants";
import {
  NOTIFICATION_TICKETS_ACTIONS
} from '../../../../../config/notifications';
import { TicketReasonModal } from '../../modals/TicketReasonModal';
import { updateTicket } from '../../../../../api/clients/tickets';
import { store } from '../../../../../store/store';
import { hideNotification } from '../../../../../store/actions/notification';

function ConfirmContactTicket(props) {
  const [ showResolveModal, setShowResolveModal ] = useState( false );

  const { index, actionCallback, ticket, showIcon } = props;

  const confirmContactTicket = (data) => {
    updateTicket( {
      ticket: data.ticket.id,
      data: {
        status: TICKETS_STATUSES.SOLVED,
        reason: data.reason,
      },
      notificationId: NOTIFICATION_TICKETS_ACTIONS
    } ).then( (response) => {
      setShowResolveModal( false );

      if (response && response.data.id) {
        actionCallback();
      }
    });
  };

  const shouldHideActionBtn = () => {
    if (! ticket || ! ACL.CLIENT.TICKETS.MANAGE.hasAccess() || ticket.status !== TICKETS_STATUSES.NEW) {
      return true;
    }
  }

  if ( shouldHideActionBtn()) {
    return null;
  }

  return ( <Fragment>
      {! showIcon ?
        <Fragment>
          <Button
            color="primary"
            size="sm"
            className="btn-warning"
            type="button"
            id={`resolve-icon-${index}`}
            onClick={() => {
              store.dispatch(hideNotification());
              setShowResolveModal( true )
            }}
          >
            <FormattedMessage
              id="components.pages.ticket.table.actionButtons.confirm_resolve_ticket"/>
          </Button>
          <UncontrolledTooltip
            delay={0}
            target={`resolve-icon-${index}`}
            modifiers={{
              preventOverflow: {
                enabled: true,
                boundariesElement: "body",
              },
            }}
            trigger="hover focus"
          >
            <FormattedMessage
              id="components.pages.ticket.table.actionButtons.confirm_resolve_ticket"/>
          </UncontrolledTooltip>
        </Fragment> :
        <Fragment>
          <Link
            to="#"
            className="cursor-pointer px-2 mx-2 link-icon-color"
            id={`resolve-icon-` + props.index}
            onClick={() => setShowResolveModal( true )}
          >
            <FontAwesomeIcon
              size="lg"
              className="cursor-pointer"
              pointerEvents="none"
              icon={faCheckDouble}
            />
          </Link>
          <UncontrolledTooltip
            delay={0}
            target={`resolve-icon-${props.index}`}
            modifiers={
              {
                preventOverflow: {
                  enabled: true,
                  boundariesElement: 'body'
                }
              }
            }
            trigger="hover focus"
          >
            <FormattedMessage
              id="components.pages.ticket.table.actionButtons.confirm_resolve_ticket"/>
          </UncontrolledTooltip>
        </Fragment>
      }

      <TicketReasonModal
        resolveTicket={true}
        showModal={showResolveModal}
        closeModal={() => setShowResolveModal( false )}
        confirmationYes={confirmContactTicket}
        ticket={ticket}
      />
    </Fragment>
  );
}

export { ConfirmContactTicket };
